import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import React, { FC } from 'react';
import * as Styled from './styled';

const LoadError: FC<{ refetch: () => void }> = ({ refetch }) => {
  const handleTryAgain = () => {
    refetch?.();
  };

  return (
    <Styled.LoadErrorWrapper data-testid="profile-error-state">
      <FuelTypography weight="bold" size="heading-sm" color="neutral-strong" spacingBottom={16}>
        Falha ao carregar as informações gerais
      </FuelTypography>
      <FuelTypography weight="medium" size="body-md" color="neutral-default" spacingBottom={32}>
        Ocorreu um erro ao carregar as informações gerais do motorista. Por favor, tente novamente.
      </FuelTypography>
      <FuelButton variant="tertiary" trailingIcon="reload" onClick={() => handleTryAgain()}>
        Tentar novamente
      </FuelButton>
    </Styled.LoadErrorWrapper>
  );
};

export default LoadError;
